const testimonials = [
  {
    name: 'Naome Precious Nalugo',
    role: 'Financial Inclusion Beneficiary, Kajjansi',
    quote:
      'The Financial Inclusion program gave me the capital to start my tailoring business. Today, I employ three other women in my community. El Hai changed the trajectory of my life.',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301171/financial_p9esyx.jpg',
  },
  {
    name: 'Anyole Muyeme Daniel',
    role: 'ICT Training Graduate, Kampala',
    quote:
      'I never thought I could work in technology. After completing the ICT Training program, I now work as a freelance web developer and support my entire family.',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301172/pro.mngr_rcs4ny.jpg',
  },
  {
    name: 'Josephine Mawazo',
    role: 'Health Program Participant',
    quote:
      'The health counseling program taught our community about nutrition and hygiene. Our children are healthier now, and we understand how to prevent common diseases.',
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774301171/health_iimb04.jpg',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-[#003366] py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3">
            Stories of Transformation
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Lives Changed, Communities Transformed
          </h2>
          <p className="text-white/60 max-w-lg mx-auto text-base">
            Hear from the people whose lives have been impacted by our programs and the generous support of our donors.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-white/10 backdrop-blur rounded-xl p-8 hover:bg-white/15 transition-colors duration-200"
            >
              <div className="text-[#ADD8E6] text-5xl font-serif leading-none mb-4">&ldquo;</div>
              <p className="text-white/80 text-sm leading-relaxed mb-6 italic">{t.quote}</p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{t.name}</p>
                  <p className="text-[#ADD8E6] text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
